import React, { useState, lazy, Suspense } from "react";
import {
  Box,
  Button,
  Dialog,
} from "@mui/material";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { useQueryClient } from "react-query";
import { getModelTrimsListPaginated } from "../../../services/vehicle";
import { getVehicleTrimDataColumns } from "./VehicleTrimDataColumns";
import OTAPagination from "../../OTAPagination";
import { CreateVehicleModelSkeleton } from "../../common/DialogSkeleton";

const CreateVehicleTrim = lazy(() => import("./CreateVehicleTrim"));
const EditVehicleTrim = lazy(() => import("./EditVehicleTrim").then(mod => ({ default: mod.EditVehicleTrim })));
const DeleteVehicleTrim = lazy(() => import("./DeleteVehicleTrim").then(mod => ({ default: mod.DeleteVehicleTrim })));

const VehicleModelTrimsTab = ({ modelId, modelName, tableSx = {} }) => {
  const queryClient = useQueryClient();

  const [addOpen, setAddOpen] = useState(false);
  const [editTrim, setEditTrim] = useState(null);
  const [deleteTrim, setDeleteTrim] = useState(null);

  const columns = getVehicleTrimDataColumns({
    onEdit: setEditTrim,
    onDelete: setDeleteTrim,
  });

  return (
    <Box sx={{ pt: 0 }}>
      {/* Add Trim Button */}
      {/* <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2 }}>
        <Button
          size="small"
          variant="contained"
          startIcon={<ControlPointIcon />}
          onClick={() => setAddOpen(true)}
        >
          Add Trim
        </Button>
      </Box> */}

      {/* Trims Table */}
      <OTAPagination
        columns={columns}
        endpointFn={({ queryKey }) => getModelTrimsListPaginated(modelId, { queryKey })}
        queryName={`modelTrims-${modelId}`}
        sortByDefault={"createdAt"}
        getRowId={(row) => row.trimId}
        paginationMode="server"
        exportCSV={false}
        defaultExport={false}
        newSx={[
          tableSx,
          {
            "& .MuiDataGrid-row:hover": {
              bgcolor: "#f9fbe7",
            },
          },
        ]}
      />

      {/* Add Trim
      {addOpen && (
        <Dialog
          open
          onClose={() => setAddOpen(false)}
          PaperProps={{ sx: { width: "45%", maxWidth: "700px" } }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <CreateVehicleTrim
              modelId={modelId}
              toggleDialog={() => setAddOpen(false)}
            />
          </Suspense>
        </Dialog>
      )} */}

      {/* Edit Trim */}
      {editTrim && (
        <Dialog
          open
          onClose={() => setEditTrim(null)}
          maxWidth="sm"
          fullWidth
          scroll="paper"
          PaperProps={{
            sx: {
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
            },
          }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <EditVehicleTrim
              trim={editTrim}
              modelId={modelId}
              toggleDialog={() => setEditTrim(null)}
            />
          </Suspense>
        </Dialog>
      )}

      {/* Delete Trim */}
      {deleteTrim && (
        <Dialog
          open
          onClose={() => setDeleteTrim(null)}
          PaperProps={{ sx: { width: "35%", maxWidth: "500px" } }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <DeleteVehicleTrim
              trim={deleteTrim}
              modelId={modelId}
              toggleDialog={() => setDeleteTrim(null)}
            />
          </Suspense>
        </Dialog>
      )}
    </Box>
  );
};

export default VehicleModelTrimsTab;